// extracted by mini-css-extract-plugin
module.exports = {"elons":"Elon_elons__3PKs9","elonScrol":"Elon_elonScrol__uv-Bs","card":"Elon_card__2J7qC","card-body":"Elon_card-body__3lKBE","card-title":"Elon_card-title__24WNz"};